var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockify2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "clockify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#05A4ED",
    d: "M1.5 12c0 6.627 5.298 12 11.835 12h.007a11.51 11.51 0 0 0 5.747-1.517l-2.656-2.695.053-.02a8.076 8.076 0 0 1-3.15.635h-.001c-4.577 0-8.287-3.78-8.287-8.44s3.71-8.44 8.287-8.44a8 8 0 0 1 3.092.613l2.611-2.65A11.644 11.644 0 0 0 13.335 0C6.799 0 1.5 5.373 1.5 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M13.277 9.961c-1.063 0-1.925.878-1.925 1.96 0 .539.214 1.028.562 1.385a1.904 1.904 0 0 0 2.728 0c.362-.373.563-.869.563-1.385 0-1.082-.864-1.96-1.928-1.96zM17.064 14.065l-1.558 1.577 5.438 5.515 1.556-1.579zM22.476 4.311l-1.557-1.577-5.438 5.514h-.001l1.558 1.577z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockify2);
export default __webpack_public_path__ + "static/media/clockify2.688a46532b456c862f6b8810138bfaf1.svg";
export { ForwardRef as ReactComponent };